<template>
  <el-container class="ReceiveNoteForm">
    <el-main class="p-0">
      <el-form
        :model="data"
        :rules="rules"
        inline
        ref="form"
        label-width="60px"
        class="columns-4"
      >
        <el-form-item label="발행일" prop="issue_date">
          <ADatePicker v-model="data.issue_date" />
        </el-form-item>
        <el-form-item label="만기일" prop="expire_date">
          <ADatePicker v-model="data.expire_date" />
        </el-form-item>
        <el-form-item label="어음번호" prop="number">
          <el-input v-model="data.number" />
        </el-form-item>
        <el-form-item label="금액" prop="price">
          <el-input-number v-model="data.price" :min="0" :max="100000000" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="거래처" prop="customer_name">
            <ACustomerSelector 
                v-model="data.customer_name" 
                @select="handleSelectCustomer" 
            />
        </el-form-item>
        <el-form-item label="담당자" prop="customer_charger">
          <el-input v-model="data.customer_charger" />
        </el-form-item>
        <el-form-item label="연락처" prop="customer_tel" class="custom-form-item" style="width: 50%;">
          <el-input v-model="data.customer_tel" />
        </el-form-item>
        <el-form-item label="기록사항" prop="desc" class="custom-form-item w-full">
          <el-input
            maxlength="200"
            type="textarea"
            class="desc_input"
            v-model="data.desc"
            :rows="2"
            placeholder="200자 이내"
            show-word-limit
          />
        </el-form-item>
      </el-form>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        v-if="isNew"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
      >등록 (F4)</el-button>
      <el-button type="primary" v-if="!isNew" @click="handleClickRegister">수정(F4)</el-button>
      <el-button type="danger" v-if="!isNew" @click="clickDel">삭 제</el-button>
      <el-button class="close-button" @click="closeDialog">{{$t('button.close')}}(Esc)</el-button>
    </el-footer>
  </el-container>
</template>
<script>
import { form } from "@/common/mixins/form";

export default {
    name: "ReceiveNoteForm",
    mixins: [form],
    data() {
        var validateValidDate = (rule, value, callback) => {
            if (!value || !this.data.issue_date) {
                callback();
                return;
            }
            if (value < this.data.issue_date) {
                callback(new Error('발행일보다 빠릅니다.'));
            } else {
                callback();
            }
        }
        return {
            rules: {
                issue_date: [ { required: true, message: '발행일을 선택하세요.' } ],
                expire_date: [ 
                    { required: true, message: '만기일을 선택하세요.' },
                    { validator: validateValidDate, trigger: ['blur',  'change'] } 
                ],
                customer_id: [ { required: true, message: '거래처를 선택해 주세요.' } ],
                price: [ { required: true, message: '금액을 입력하세요.' } ],
            }
        }
    },
    props: {
        data: {
            type: Object,
            default: function () {
                return {
                    id: 0,                    
                    issue_date: this.util.getDateString(this.util.getDate(0)),
                    expire_date: this.util.getDateString(this.util.getDate(30)),
                    number: '',
                    price: 0,
                    customer_id: 0,                 
                    customer_name: '', 
                    customer_charger: '',
                    customer_tel: '', 
                    desc: '',
                }
            }
        },
        flag: {
              type: String,
              default: 'R'
          }
    },
    computed:{
        isNew: function() {
            return this.data.id < 1
        },
    },
    methods: {
        handleClickRegister() {            
            this.$refs.form.validate((valid) => {
                if (!valid) { return; }
                this.doRegister();
            });
        },        
        handleSelectCustomer(c) {
            if (typeof(c) === 'string') {
                this.data.customer_id = null;
                this.data.customer_name = c;
                this.data.customer_tel = '';
            } else {
                this.data.customer_id = c.id;
                this.data.customer_name = c.name;
                this.data.customer_tel = c.tel || c.tel2 || c.owner_tel;
            }
        },        
        doRegister() {
            let data = Object.assign({}, this.data);
            data.flag = this.flag
            if(this.isNew){
                this.api.createNote(data).then(res => {
                    if (res.error !== this.system.noError) {
                        this.notifyError(res.message);
                    } else {
                        this.completed("등록되었습니다.");
                    }
                });
            }else{
                this.api.updateNote(data).then(res => {
                    if (res.error !== this.system.noError) {
                        this.notifyError(res.message);
                    } else {
                        this.completed("수정되었습니다.");
                    }
                });
            }
        },
         clickDel() {        
            this.util.confirm_delete(this, '어음[' + this.data.customer_name + ']', this.doDelete);
        },
        doDelete() {
            const data = this.organizeData();
            this.api.deleteNote(data).then(res => {
                if (res.error !== this.system.noError) {
                    this.notifyError(res.message);
                } else {
                    this.completed("삭제되었습니다.");
                }
            });
        },
        /** 데이터 값 정리 */
        organizeData() {
            let param = Object.assign({}, this.data);
            //param.crn = this.util.remove_dash(param.crn);
            //param.ssn = this.util.remove_dash(param.ssn);
            return param;
        },
        handleResult(res, successMessage) {
            if (res.error === this.system.noError) { 
                const options = this.getNotifyOptions(successMessage);
                this.$emit('completed', options);
                return; 
            }
            this.util.notify_error(this, "어음", res.message);
        },
        /** noti 옵션 반환 */
        getNotifyOptions(message) {
            return this.util.get_notify_options('s', "어음", message);
        },        
        notifyError(message) {
            this.util.notify_error(this, "어음", message);
        },
        completed(message) {
            const options = this.util.get_notify_options('s', "어음", message);
            this.$emit('completed', options);
        },
    }
}
</script>
<style lang="scss" scoped>
.desc_input {
  width: 714px;
}
</style>
